export const arrayMenuHoteleria = [
  {
    id: 1,
    key: 'gestion-del-servicio',
    name: 'Gestión del Servicio',
    vista: '#GESTION DEL SERVICIO',
    arraySubItem: [
      {
        id: 2,
        title: 'Módulos',
        showPanel: false,
        vista: '#MODULOS',
        content: {
          headerPanel: 'table-modules',
        },
        closable: true,
        submenu: 'modules',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 3,
        title: 'Habitaciones',
        showPanel: false,
        vista: '#HABITACIONES',
        content: {
          headerPanel: 'table-rooms',
        },
        closable: true,
        submenu: 'rooms',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 4,
        title: 'Camas',
        showPanel: false,
        vista: '#CAMAS',
        content: {
          headerPanel: 'table-beds',
        },
        closable: true,
        submenu: 'beds',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 6,
        title: 'Huéspedes',
        showPanel: false,
        vista: '#HUESPEDES',
        content: {
          headerPanel: 'header-guests',
        },
        closable: true,
        submenu: 'guests',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 9,
        title: 'Cambio de Habitaciones',
        showPanel: false,
        vista: '#CAMBIO DE HABITACIONES',
        content: {
          headerPanel: 'header-change-rooms',
        },
        closable: true,
        submenu: 'change-rooms',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 10,
        title: 'Control y estado de Módulos y Habitaciones',
        showPanel: false,
        vista: '#CONTROL Y ESTADO DE MODULOS Y HABITACIONES',
        content: {
          headerPanel: 'header-control-status',
        },
        closable: true,
        submenu: 'control-status',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 11,
        title: 'Anulaciones y cambios',
        showPanel: false,
        vista: '#ANULACIONES Y CAMBIOS',
        content: {
          headerPanel: 'header-anulaciones-cambios',
        },
        closable: true,
        submenu: 'anulaciones-cambios',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
    ],
  },
  {
    id: 2,
    key: 'gestion-de-reserva',
    name: 'Gestión de Reserva',
    vista: '#GESTION DE RESERVA',
    arraySubItem: [
      {
        id: 5,
        title: 'Reservas',
        showPanel: false,
        vista: '#RESERVAS',
        content: {
          headerPanel: 'header-bookings',
        },
        closable: true,
        submenu: 'bookings',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 6,
        title: 'Check in',
        showPanel: false,
        vista: '#CHECKIN',
        content: {
          headerPanel: 'table-checkin',
        },
        closable: true,
        submenu: 'checking',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 7,
        title: 'Check out',
        showPanel: false,
        vista: '#CHECK OUT',
        content: {
          headerPanel: 'table-checkout',
        },
        closable: true,
        submenu: 'checkout',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      // {
      //   id: 8,
      //   title: 'Consulta de Disponibilidad',
      //   showPanel: false,
      //   content: {
      //     headerPanel: 'header-availability',
      //   },
      //   closable: true,
      //   submenu: 'availability',
      //   idToEdit: '',
      //   loadingTable: false,
      //   deleted: false,
      //   updated: false,
      // },
      {
        id: 9,
        title: 'Historial de Hospedaje',
        showPanel: false,
        vista: '#HISTORIAL DE HOSPEDAJE',
        content: {
          headerPanel: 'table-hosting-history',
        },
        closable: true,
        submenu: 'hostingHistory',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 10,
        title: 'Términos y condiciones',
        showPanel: false,
        vista: '#TERMINOS Y CONDICIONES',
        content: {
          headerPanel: 'header-tyc',
        },
        closable: true,
        submenu: 'tyc',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 11,
        title: 'Reservas Presenciales',
        showPanel: false,
        vista: '#RESERVAS PRESENCIALES',
        content: {
          headerPanel: 'form-booking-face-to-face',
        },
        closable: true,
        submenu: 'booking-face-to-face',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
    ],
  },
  {
    id: 3,
    key: 'gestion-de-ocupabilidad',
    name: 'Gestión de Ocupabilidad',
    vista: '#GESTION DE OCUPABILIDAD',
    arraySubItem: [
      {
        id: 2,
        title: 'Ocupabilidad',
        showPanel: false,
        vista: '#OCUPABILIDAD',
        content: {
          headerPanel: '',
        },
        closable: true,
        submenu: 'occupancy',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
    ],
  },
  {
    id: 4,
    key: 'consultas-check-in-out',
    name: 'Consultas',
    vista: '#CONSULTAS',
    arraySubItem: [
      {
        id: 2,
        title: 'Check in del día',
        showPanel: false,
        vista: '#CHECKIN DEL DIA',
        content: {
          headerPanel: 'table-checkIn-list',
        },
        closable: true,
        submenu: 'checkInList',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 3,
        title: 'Check out del día',
        showPanel: false,
        vista: '#CHECKOUT DEL DIA',
        content: {
          headerPanel: 'table-checkOut-list',
        },
        closable: true,
        submenu: 'checkOutList',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 4,
        title: 'Huéspedes',
        showPanel: false,
        vista: '#CHUESPEDES',
        content: {
          headerPanel: 'header-guest-list',
        },
        closable: true,
        submenu: 'guestList',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 5,
        title: 'Reservas por Integración',
        showPanel: false,
        vista: '#RESERVAS POR INTEGRACION',
        content: {
          headerPanel: 'header-booking-integration',
        },
        closable: true,
        submenu: 'booking-integration',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 6,
        title: 'Huéspedes Retirados',
        showPanel: false,
        vista: '#HUESPEDES RETIRADOS',
        content: {
          headerPanel: 'header-retired-guests',
        },
        closable: true,
        submenu: 'retired-guests',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
    ],
  },
  {
    id: 5,
    key: 'reportes-hoteleria',
    name: 'Reportes',
    vista: '#REPORTES HOTELERIA',
    arraySubItem: [
      {
        id: 2,
        title: 'Generar Detalle de Reportes de Facturación',
        showPanel: false,
        vista: '#REPORTE DE FACTURACION',
        content: {
          headerPanel: 'table-reportes',
        },
        closable: true,
        submenu: 'reportes',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 3,
        title: 'Reportes de Facturacion',
        showPanel: false,
        vista: '#REPORTE DE FACTURACION SUB',
        content: {
          headerPanel: 'table-reportes-sub',
        },
        closable: true,
        submenu: 'reportes-sub',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 4,
        title: 'Ratios de Checkin y Checkout',
        showPanel: false,
        vista: '#REPORTE DE RATIOS DE CHECKIN Y CHECKOUT',
        content: {
          headerPanel: 'reportes-ratios-checkin-checkout',
        },
        closable: true,
        submenu: 'reportes-ratios-checkin-checkout',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 5,
        title: 'Ratios Rooming List',
        showPanel: false,
        vista: '#REPORTE DE RATIOS ROOMING LIST',
        content: {
          headerPanel: 'reportes-ratios-rooming-list',
        },
        closable: true,
        submenu: 'reportes-ratios-rooming-list',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 6,
        title: 'Ratios Resumen de Ventas',
        showPanel: false,
        vista: '#REPORTE DE RATIOS RESUMEN DE VENTAS',
        content: {
          headerPanel: 'reportes-ratios-resumen-ventas',
        },
        closable: true,
        submenu: 'reportes-ratios-resumen-ventas',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 7,
        title: 'Ratios Detalle de Ventas',
        showPanel: false,
        vista: '#REPORTE DE RATIOS DETALLE DE VENTAS',
        content: {
          headerPanel: 'reportes-ratios-detalle-ventas',
        },
        closable: true,
        submenu: 'reportes-ratios-detalle-ventas',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 8,
        title: 'Ratios de Ocupabilidad',
        showPanel: false,
        vista: '#REPORTE DE RATIOS DE OCUPABILIDAD',
        content: {
          headerPanel: 'reportes-ratios-ocupabilidad',
        },
        closable: true,
        submenu: 'reportes-ratios-ocupabilidad',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 9,
        title: 'Ratios de Disponibilidad y Ocupabilidad',
        showPanel: false,
        vista: '#REPORTE DE RATIOS DE DISPONIBILIDAD',
        content: {
          headerPanel: 'reportes-ratios-disponibilidad',
        },
        closable: true,
        submenu: 'reportes-ratios-disponibilidad',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 10,
        title: 'Resumen de Estadía',
        showPanel: false,
        vista: '#REPORTE DE RATIOS DE ESTADIA',
        content: {
          headerPanel: 'reportes-ratios-estadia',
        },
        closable: true,
        submenu: 'reportes-ratios-estadia',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 11,
        title: 'Gráfica de Ocupabilidad',
        showPanel: false,
        vista: '#REPORTE DE OCUPABILIDAD',
        content: {
          headerPanel: 'reportes-ocupabilidad',
        },
        closable: true,
        submenu: 'reportes-ocupabilidad',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 12,
        title: 'Reporte de Valoración',
        showPanel: false,
        vista: '#REPORTE DE VALORACION',
        content: {
          headerPanel: 'header-report-valoration',
        },
        closable: true,
        submenu: 'reportes-valoration',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 13,
        title: 'Lista Camas Preferentes',
        showPanel: false,
        vista: '#REPORTE DE CAMAS',
        content: {
          headerPanel: 'reportes-camas-preferentes',
        },
        closable: true,
        submenu: 'reportes-camas-preferentes',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
    ],
  },
  {
    id: 6,
    key: 'checkin',
    name: 'CheckIn/CheckOut',
    vista: '#CHECKIN HOTELERIA',
    arraySubItem: [
      {
        id: 2,
        title: 'Checkin/Checkout Autoservicio',
        showPanel: true,
        vista: '#CHECKIN AUTOSERVICIO',
        content: {
          headerPanel: 'header-checkin-autoservicio',
        },
        closable: true,
        submenu: 'checkin-autoservicio',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 3,
        title: 'Checkin/Checkout Parqueo de Buses',
        showPanel: true,
        vista: '#CHECKIN PARQUEO DE BUSES',
        content: {
          headerPanel: 'header-checkin-parqueo',
        },
        closable: true,
        submenu: 'checkin-parqueo',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 4,
        title: 'Checkin/Checkout Autoservicio Automatico',
        showPanel: true,
        vista: '#CHECKIN AUTOSERVICIO AUTOMATICO',
        content: {
          headerPanel: 'header-checkin-autoservicio-automatico',
        },
        closable: true,
        submenu: 'checkin-autoservicio-automatico',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
    ],
  },
  {
    id: 7,
    key: 'app-huesped',
    name: 'App Huesped',
    vista: '#APP HUESPED',
    arraySubItem: [
      {
        id: 2,
        title: 'Reservas App',
        showPanel: false,
        vista: '#RESERVAS APP HUESPED',
        content: {
          headerPanel: 'header-reservas-app-huesped',
        },
        closable: true,
        submenu: 'reservas-app-huesped',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 3,
        title: 'Checkin App',
        showPanel: false,
        vista: '#CHECKIN APP HUESPED',
        content: {
          headerPanel: 'header-checkin-app-huesped',
        },
        closable: true,
        submenu: 'checkin-app-huesped',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
      {
        id: 4,
        title: 'Checkout App',
        showPanel: true,
        vista: '#CHECKOUT APP HUESPED',
        content: {
          headerPanel: 'header-checkout-app-huesped',
        },
        closable: true,
        submenu: 'checkout-app-huesped',
        idToEdit: '',
        loadingTable: false,
        deleted: false,
        updated: false,
      },
    ],
  },
]
